import Resource from './Resource';

class Ui3Handoff extends Resource {
	constructor() {
		super('ui3Handoff');
	}

	create(next: string): Promise<string> {
		return this._postRequest('', { next }, { methodName: 'create' }).then(res => res.data.data.url);
	}
}

export default new Ui3Handoff();
